import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CurrencyRubleIcon(props: IconProps) {
    return <Icon {...props} iconKey={"currency_ruble"}/>
}
